module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAQCAYAAAD52jQlAAAAAXNSR0IArs4c6QAAAJlJREFUOBFj+G9n5wXEGxmoAGBmsTAwMTEx/PvHTAUzGRgPHdoGNGcbEzUMw2rG/4YGqhkOMosRqy1kCv53cPABBmUG1VyI7A4mWIwhC5LN/vfvH1Dv39HYJzsEMTSOxj4477NAA0YUFkD/7e1TgblCBsxnZZ3FuG/fUxCbFHEmxgMHtjBwc/vADGX4//8fAyMjBDMz/ydHHACQpGDGfgU9sgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/chart5-icon/Auto Suspend.png
// module id = 304
// module chunks = 7